import React from 'react';
import { useParams, Link } from 'react-router-dom';

const WorkflowDetail: React.FC = () => {
  const { executionArn } = useParams<{ executionArn: string }>();

  return (
    <div>
      <div className="mb-8">
        <Link to="/workflows" className="text-blue-600 hover:text-blue-800 mb-4 inline-block">
          ← Back to Workflows
        </Link>
        <h1 className="text-3xl font-bold text-gray-900">Workflow Details</h1>
        <p className="mt-2 text-gray-600">
          View execution details and status
        </p>
      </div>

      <div className="bg-white shadow rounded-lg">
        <div className="px-6 py-4 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Execution Information</h2>
        </div>
        <div className="p-6">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Execution ARN</label>
              <p className="mt-1 text-sm text-gray-900 font-mono break-all">
                {executionArn ? decodeURIComponent(executionArn) : 'Loading...'}
              </p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Status</label>
              <p className="mt-1 text-sm text-gray-900">Loading...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkflowDetail;
